// API Configuration for different environments
export const apiConfig = {
    // Base URL for the backend API - automatically detects environment
    baseUrl: getBackendUrl(),
    
    // API endpoints
    endpoints: {
        chat: "/api/chat",
        quota: "/api/quota"
    },
    
    // Get full URL for an endpoint
    getUrl(endpoint) {
        return `${this.baseUrl}${this.endpoints[endpoint]}`;
    }
};

// Auto-detect backend URL based on frontend URL
function getBackendUrl() {
    const hostname = window.location.hostname;
    
    // Check if running locally — use a relative URL so the webpack dev-server
    // proxy forwards the request (avoids all CORS issues)
    if (hostname === 'localhost') {
        return "";
    }
    
    // Check if on test frontend (Storage Static Website or Static Web App)
    if (hostname.includes('caeleatest') || hostname.includes('lea-test') || hostname.includes('ashy-bay')) {
        return "https://lea-backend-test.wittybay-20fd241b.germanywestcentral.azurecontainerapps.io";
    }
    
    // Production (Storage Static Website, Static Web App, or custom domain)
    // Matches: caeida.z49..., zealous-ocean-..., lea.caeexpert.group
    return "https://lea-backend.redfield-67f1ab20.germanywestcentral.azurecontainerapps.io";
}